import * as angular from "angular";
import { EffortDataProvider } from "./effort.dp";
import { Appointment } from "../models/appointment.model";
import { AppointmentService } from "../services/appointment.service";
import { AppointmentFilter } from "../models/appointment-filter.model";
import { CheckManager } from "../shared/check-manager";

export class AppointmentDataProvider {
    private $q: any;
    private $filter: any;
    private service: AppointmentService;
    private effortDataProvider: EffortDataProvider;
    private modelsUtils: any;

    constructor(
        $q: any,
        $filter: any,
        AppointmentService: AppointmentService,
        EffortDataProvider: EffortDataProvider,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.$filter = $filter;
        this.service = AppointmentService;
        this.effortDataProvider = EffortDataProvider;

        this.modelsUtils = ModelsUtils;
    }

    all(filters: AppointmentFilter, offset: number): Promise<Appointment[]> {
        const deferred = this.$q.defer();

        this.service
            .all({ filters: filters.nonEmptyValues(), offset: offset })
            .then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        deferred.resolve(json);
                    } else {
                        deferred.reject(json);
                    }
                },
                (response: object) => deferred.reject(response)
            );

        return deferred.promise;
    }

    info(id: string | number): Promise<Appointment> {
        const deferred = this.$q.defer();

        this.service.info({ id: id }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(this.modelsUtils.appointment(json.data));
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    create(appointment: Appointment): Promise<any> {
        let deferred = this.$q.defer();

        this.service.create(appointment).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    update(appointment: Appointment): Promise<any> {
        const deferred = this.$q.defer();

        appointment.appointmenttime = new Date(appointment.appointmenttime);
        this.service.update(appointment).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    delete(appointment: Appointment): Promise<boolean> {
        const deferred = this.$q.defer();

        this.service.delete({ id: appointment.id }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data[0]);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    bulkEdit(
        fieldEdit: any,
        filters: AppointmentFilter,
        checkManager: CheckManager
    ): Promise<any> {
        const deferred = this.$q.defer();

        let callBack = (response: object) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        };

        let errorCallback = (error: object) => {
            deferred.reject(error);
        };
        let bulkActionData = checkManager.bulkActionData(filters);
        bulkActionData["fieldEdit"] = fieldEdit;
        this.service.bulk_edit(bulkActionData).then(callBack, errorCallback);

        return deferred.promise;
    }

    bulkDelete(
        filters: AppointmentFilter,
        checkManager: CheckManager
    ): Promise<any> {
        const deferred = this.$q.defer();

        let callBack = (response: object) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        };

        let errorCallback = (error: object) => {
            deferred.reject(error);
        };
        let bulkActionData = checkManager.bulkActionData(filters);
        this.service.bulk_delete(bulkActionData).then(callBack, errorCallback);

        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("AppointmentDataProvider", AppointmentDataProvider);
